import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import axios from "../../axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import Title from "../../new-components/title/Title";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Rating } from "primereact/rating";
import NewFooter from "../../NewFooter";
import SpaLoader from "../../Components/Loaders/SpaLoader";

function Feedback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";
  const lang = sessionStorage.getItem("lang");

  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [open, setOpen] = useState(false);

  const [feedbackCategories, setFeedbackCategories] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [generalFeedback, setGeneralFeedback] = useState("");
  const [improvementSuggestions, setImprovementSuggestions] = useState("");
  const [title, setTitle] = useState("");
  const businessName = localStorage.getItem("business_name");
  // const [businessType, setBusinessType] = useState("");
  const [information, setInformation] = useState();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleRatingChange = (categoryIndex, subCategoryIndex, value) => {
    setRatings((prev) => {
      const updatedRatings = [...prev];

      updatedRatings[categoryIndex] = {
        ...updatedRatings[categoryIndex],
        sub_categories: [...updatedRatings[categoryIndex].sub_categories],
      };

      updatedRatings[categoryIndex].sub_categories[subCategoryIndex] = {
        ...updatedRatings[categoryIndex].sub_categories[subCategoryIndex],
        rating: value || 0,
      };

      return updatedRatings;
    });
  };

  const handleNoteChange = (categoryIndex, value) => {
    setRatings((prev) => {
      const updatedRatings = [...prev];

      updatedRatings[categoryIndex] = {
        ...updatedRatings[categoryIndex],
        notes: value,
      };

      return updatedRatings;
    });
  };

  const allRatingsAboveEight = () => {
    const selectedRatings = ratings
      .map((category) => {
        const selectedSubCategories = category.sub_categories.filter(
          (subCategory) => subCategory.rating !== 0
        );

        return {
          ...category,
          sub_categories: selectedSubCategories,
        };
      })
      .filter((category) => category.sub_categories.length > 0);

    if (selectedRatings.length === 0) return false;

    return selectedRatings.every((category) =>
      category.sub_categories.every((subCategory) => subCategory.rating >= 4)
    );
  };

  const allRatingsEqualZero = () => {
    return ratings.every((category) =>
      category.sub_categories.every((subCategory) => subCategory.rating === 0)
    );
  };
  const allNoteDontEmpty = () => {
    return ratings.some((category) => category.notes?.trim() !== "");
  };

  const clickOnAdvOrGoogle = (type) => {
    axios
      .post(
        `/${room_uuid}/feedback/click`,
        { link_type: type },
        {
          headers: { lang },
        }
      )
      .then((res) => {})
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleSendFeedback = async (e) => {
    e.preventDefault();
    setLoadingForm(true);
    const formData = new FormData();
    let ratingIndex = 0;
    ratings.forEach((category) => {
      const selectedSubCategories = category.sub_categories.filter(
        (subCategory) => Number(subCategory.rating) > 0
      );

      const hasNote = category.notes?.trim();

      if (selectedSubCategories.length === 0 && !hasNote) {
        return;
      }

      formData.append(
        `ratings[${ratingIndex}][category_id]`,
        String(category.category_id)
      );

      selectedSubCategories.forEach((subCategory, subCategoryIndex) => {
        formData.append(
          `ratings[${ratingIndex}][sub_categories][${subCategoryIndex}][sub_category_id]`,
          String(subCategory.sub_category_id)
        );

        formData.append(
          `ratings[${ratingIndex}][sub_categories][${subCategoryIndex}][rating]`,
          String(subCategory.rating)
        );
      });

      if (hasNote) {
        formData.append(
          `ratings[${ratingIndex}][notes]`,
          category.notes.trim()
        );
      }

      ratingIndex++;
    });

    formData.append("general_feedback", generalFeedback || "");
    formData.append("improvement_suggestions", improvementSuggestions || "");

    try {
      const res = await axios.post(`/${room_uuid}/store-feedback`, formData, {
        headers: {
          lang,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        ReactGA.event({
          category: "Send Feedback",
          action: "Click",
          value: "",
        });

        if (allRatingsAboveEight()) {
          setOpen(true);
        } else {
          navigate(`/${room_uuid}/qr-code`);
          toast.success(
            t(
              "Thank you, we’ve received your feedback and will work diligently to enhance our services."
            ),
            {
              className: theme ? "custom-toast" : "",
              bodyClassName: theme ? "custom-toast" : "",
              progressClassName: theme ? "custom-toast" : "",
            }
          );
        }

        setGeneralFeedback("");
        setImprovementSuggestions("");
      }
    } catch (err) {
      console.error("Error:", err);

      toast.error(err?.response?.data?.message || t("Something went wrong."), {
        className: theme ? "custom-toast" : "",
        bodyClassName: theme ? "custom-toast" : "",
        progressClassName: theme ? "custom-toast" : "",
      });
    } finally {
      setLoadingForm(false);
    }
  };
  useEffect(() => {
    setLoading(true);

    axios
      .get(`/${room_uuid}/feedback`, { headers: { lang } })
      .then((res) => {
        if (res.data.status === false || res.data.success === false) {
          navigate(`/${room_uuid}/qr-scan`);
          return;
        }

        const data = res.data.data;
        setFeedbackCategories(data.feedbackCategories || []);
        // setInformation(data?.feedbackSettings?.[0]);
        setRatings(
          (data.feedbackCategories || []).map((category) => ({
            category_id: category.id,
            sub_categories: (category.sub_categories || []).map(
              (subCategory) => ({
                sub_category_id: subCategory.id,
                rating: 0,
              })
            ),
            notes: "",
          }))
        );
      })
      .catch((err) => {
        console.error("Error:", err);

        toast.error(t("Something went wrong."), {
          className: theme ? "custom-toast" : "",
          bodyClassName: theme ? "custom-toast" : "",
          progressClassName: theme ? "custom-toast" : "",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [room_uuid, lang, navigate, t, theme]);

  return (
    <div className={theme ? "food" : ""}>
      {theme ? (
        <Title title={t("Guest Review")} />
      ) : (
        <HeaderInner headerName={t("Guest Review")} />
      )}
      {loading ? (
        <SpaLoader />
      ) : (
        <main
          className="home-main pad-top-0 back-white feedBack_page"
          style={{ minHeight: "auto" }}
        >
          <p className="text_feed px-4">
            {t(
              "Thank you for choosing to stay with us. We value your feedback and would appreciate if you could take a few minutes to share your experience."
            )}
          </p>
          <form onSubmit={handleSendFeedback}>
            <Accordion
              activeIndex={0}
              expandIcon="fa fa-plus"
              collapseIcon="fa fa-minus"
              className="mb-4"
            >
              {feedbackCategories.map((item, categoryIndex) => (
                <AccordionTab
                  key={categoryIndex}
                  header={
                    <span className="feedback_icon">
                      <img src={item.icon} alt="" />
                      <p>{item.name}</p>
                    </span>
                  }
                  disabled={false}
                >
                  <ul className="rating_list">
                    {item.sub_categories.map(
                      (subCategory, subCategoryIndex) => (
                        <li key={subCategory.id}>
                          <p className="rating_title">{subCategory.name}</p>
                          <div className="rating_box">
                            <Rating
                              value={
                                ratings[categoryIndex]?.sub_categories[
                                  subCategoryIndex
                                ]?.rating
                              }
                              onChange={(e) =>
                                handleRatingChange(
                                  categoryIndex,
                                  subCategoryIndex,
                                  e.value
                                )
                              }
                              cancel={false}
                              stars={5}
                            />
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                  {item.with_note === 1 && (
                    <Form.Group className="mb-3 w-100">
                      <Form.Control
                        as="textarea"
                        value={ratings[categoryIndex]?.notes || ""}
                        onChange={(e) =>
                          handleNoteChange(categoryIndex, e.target.value)
                        }
                        placeholder={t("Note (optional)")}
                        style={{ height: "70px" }}
                      />
                    </Form.Group>
                  )}
                </AccordionTab>
              ))}
            </Accordion>
            <div className="px-2">
              <Form.Group className="mb-3 w-100">
                <Form.Control
                  as="textarea"
                  required={allRatingsEqualZero() && !allNoteDontEmpty()}
                  value={generalFeedback}
                  onChange={(e) => setGeneralFeedback(e.target.value)}
                  placeholder={
                    !businessName?.includes("Meeting")
                      ? t(
                          "Is there anything else you would like to share about your stay?"
                        )
                      : t(
                          "Is there anything else you would like to share about your experience"
                        )
                  }
                  style={{ height: "70px" }}
                />
              </Form.Group>
              <Form.Group className="mb-3 w-100">
                <Form.Control
                  as="textarea"
                  value={improvementSuggestions}
                  onChange={(e) => setImprovementSuggestions(e.target.value)}
                  required={allRatingsEqualZero() && !allNoteDontEmpty()}
                  placeholder={t(
                    "How can we improve your experience in the future?"
                  )}
                  style={{ height: "70px" }}
                />
              </Form.Group>
            </div>
            <div className="padd-div text-center mb-2 ">
              <Button
                className="reg-btn order-btn"
                type="submit"
                // onClick={handleSendFeedback}
                disabled={loadingForm}
              >
                {t("Submit")}
              </Button>
            </div>
          </form>
        </main>
      )}
      {theme && <NewFooter />}
      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        className={`${theme ? "food-modal rate_modal" : ""} rate_modal p-0`}
        style={{
          minHeight: "150px",
          padding: "0px !important",
          display: "flex !important",
          alignItems: "center !important",
          paddingRight: "0 !important",
        }}
      >
        <Modal.Body style={{ padding: "20px 10px", height: "auto" }}>
          <span className="check_feed">
            <i className="fas fa-check"></i>
          </span>

          <h5 className="feed_done">{t("Done")}</h5>
          <p className="text_feed">
            {t(
              "Thank you for your feedback! We hope to welcome you again soon."
            )}
            <br />
            {t("Please rate us on")}
          </p>
          {allRatingsAboveEight() ? (
            <div className="feed_logos">
              {information?.trip_advisor && (
                <a
                  onClick={() => clickOnAdvOrGoogle("trip_advisor")}
                  target="_blank"
                  href={information?.trip_advisor}
                  className=""
                >
                  <img
                    src={"https://d3l5wxnahfuscp.cloudfront.net/fed_trip_b.png"}
                    alt=""
                  />
                </a>
              )}
              {information?.review_link && (
                <a
                  onClick={() => clickOnAdvOrGoogle("google")}
                  target="_blank"
                  href={information?.review_link}
                  className=""
                >
                  <img
                    src={
                      "https://d3l5wxnahfuscp.cloudfront.net/fed_google_b.png"
                    }
                    alt=""
                  />
                </a>
              )}
            </div>
          ) : (
            <div className="feed_btns">
              <a
                href={`tel:${information?.manager_number}`}
                className="feed_btns"
                target="_blank"
              >
                Contact the Manager
              </a>
            </div>
          )}
          <div className="feed_btns">
            <button
              onClick={() => navigate(`/${room_uuid}/qr-code`)}
              className="feed_btns"
            >
              {t("Back to Home")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Feedback;
